import React from "react";
import { Box, TextField, InputAdornment, Tooltip, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { MascaraCpf } from "../../../../utils/MascaraCpf";
import { MascaraTelefone } from "../../../../utils/MascaraTelefone";

const fieldSx = {
    "& .MuiOutlinedInput-root": {
        backgroundColor: "white",
        borderRadius: "10px",
        "&.Mui-focused fieldset": {
            borderColor: "#0b243d",
        },
    },
    "& .MuiInputLabel-root.Mui-focused": {
        color: "#0b243d",
    },
};

// Desktop: campos largos (65%) e estreitos (35%) dividem a linha descontando o gap de 20px
const wideFieldSx = { ...fieldSx, width: { xs: "100%", md: "calc(65% - 10px)" } };
const narrowFieldSx = { ...fieldSx, width: { xs: "100%", md: "calc(35% - 10px)" } };

const InfoAdornment = ({ title }) => (
    <InputAdornment position="end">
        <Tooltip title={title} arrow placement="top">
            <InfoOutlinedIcon
                sx={{
                    fontSize: 18,
                    color: "text.secondary",
                    cursor: "help",
                    "&:hover": { color: "#0b243d" },
                }}
            />
        </Tooltip>
    </InputAdornment>
);

const StepOne = ({ nome, setNome, telefone, setTelefone, cpf, setCpf, email, setEmail }) => {
    return (
        <Box sx={{ width: "100%" }}>
            <Typography sx={{ mt: 0, mb: "20px", fontSize: { xs: "0.9rem", md: "0.95rem" }, color: "#555" }}>
                Preencha seus dados para iniciarmos o seu cadastro.
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "20px",
                }}
            >
                <TextField label="Nome Completo" required variant="outlined" size="small" sx={wideFieldSx} value={nome} onChange={(e) => setNome(e.target.value)} />
                <TextField label="Telefone (WhatsApp)" required variant="outlined" size="small" sx={narrowFieldSx} value={telefone} onChange={(e) => setTelefone(MascaraTelefone(e.target.value))}
                    placeholder="(00) 0 0000-0000"
                    slotProps={{
                        input: {
                            endAdornment: <InfoAdornment title="Pedimos seu telefone para agilizar o contato caso precisemos falar com você." />,
                        },
                    }}
                />
            
                <TextField label="CPF" required variant="outlined" size="small" sx={narrowFieldSx} value={cpf} onChange={(e) => setCpf(MascaraCpf(e.target.value))}
                    placeholder="000.000.000-00"
                    slotProps={{
                        input: {
                            endAdornment: <InfoAdornment title="Usamos seu CPF apenas para validar cadastro e contrato. Seus dados são protegidos conforme a LGPD." />,
                        },
                    }}
                />
                <TextField label="E-mail" required variant="outlined" size="small" sx={wideFieldSx} value={email} onChange={(e) => setEmail(e.target.value.replace(/\s/g, "").toLowerCase())}
                    type="email" placeholder="seuemail@exemplo.com"
                    slotProps={{
                        input: {
                            endAdornment: <InfoAdornment title="Precisamos do seu e-mail para criar o seu acesso à plataforma Clarea Vital." />,
                        },
                    }}
                />
            </Box>
        </Box>
    )
}

export default StepOne;
